module.exports = __webpack_public_path__ + "img/Dach ausgebaut_1.94965a9b.svg";